<template>
  <button
    :type="type"
    :class="classComputed"
    @mouseover="isHover = true"
    @mouseleave="isHover = false"
    @focus="isFocus = true"
    @blur="isFocus = false"
    :disabled="disabled || loading"
  >
    <template v-if="loading">
      <i class="el-icon-loading"></i>
    </template>
    <template v-else>
      <slot name="icon" :isHover="isHover" :isFocus="isFocus">
        <i v-if="icon">
          <font-awesome-icon :icon="icon" size="1x"></font-awesome-icon>
        </i>
      </slot>
    </template>
    <span>
      <slot></slot>
    </span>
  </button>
</template>

<script>
export default {
  data() {
    return {
      isHover: false,
      isFocus: false,
    };
  },
  props: {
    classes: [Object, Array],
    label: String,
    icon: String,
    type: {
      type: String,
      default() {
        return "button";
      },
      validator(val) {
        return ["button", "submit", "reset"].indexOf(val) > -1;
      },
    },
    theme: String,
    round: Boolean,
    // 不填滿背景色，僅外框
    border: Boolean,
    // 滑鼠移過樣式是否僅框線
    hoverBorderOnly: Boolean,
    // 填滿按鈕
    fill: Boolean,
    // 漸層填滿
    activeGradient: Boolean,
    loading: Boolean,
    disabled: Boolean,
  },
  computed: {
    classComputed() {
      let classes = this.classes;

      if (!Array.isArray(classes)) {
        classes = [classes];
      }

      if (this.theme) {
        classes.push("tg-btn-" + this.theme);
      }

      return [
        "tg-btn",
        {
          "has-icon": !!this.icon || this.$scopedSlots["icon"],
          "has-border": this.border,
          "is-round": this.round,
          "hover-border-only": this.hoverBorderOnly,
          "is-fill": this.fill,
          "active--gradient": this.activeGradient,
        },
        ...classes,
      ];
    },
  },
};
</script>
